import { ImmomioButtonComponent } from '@immomio/ui/button';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalContentComponent } from '../modal/modal-content/modal-content.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-new-update-banner',
  templateUrl: './new-update-banner.component.html',
  styleUrls: ['./new-update-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalComponent,
    ModalContentComponent,
    TranslatePipe
  ]
})
export class NewUpdateBannerComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  onUpdate() {
    this.ngbActiveModal.close();
  }
}
